module.exports = __webpack_public_path__ + "img/DEEZ.20eca589.svg";